<template>
  <div
    class="indicator"
  >
    <div class="line minus"/>
    <transition name="plus">
      <div
        v-if="!expanded"
        class="line plus"
      />
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      expanded: {
        type: Boolean,
        required: true,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  $size: 24px;

  .indicator {
    position: relative;
    width: $size;
    height: $size;
  }

  .line {
    position: absolute;
    top: $size / 2;
    border-top: border(bronze);
    width: 100%;
  }

  .plus {
    transform: translateY(-50%) rotate(90deg) scaleX(1);
    transform-origin: center;
  }

  .plus-enter,
  .plus-leave-to {
    transform: translateY(-50%) rotate(90deg) scaleX(0);
  }

  .plus-enter-active,
  .plus-leave-active {
    transition-duration: duration(fast);
    transition-property: transform;
    transition-timing-function: timing-function(standard);
  }

  .minus {
    transform: translateY(-50%);
  }

</style>
